module.exports = __webpack_public_path__ + "img/portfolio_bootstrap.fd580b88.jpg";